<div id="rent-a-car">
  <ng-container *ngFor="let day of days; let index = index">
    <app-vehicles [day]="day" [version]="version" [noImageUrl]="noImageUrl" [defaultImage]="defaultImage"
      [replaceShowDescriptionButtonWithNotes]="replaceShowDescriptionButtonWithNotes" [serviceIcons]="serviceIcons"></app-vehicles>
  </ng-container>
</div>
